import { render, staticRenderFns } from "./ShowHotelEdits.vue?vue&type=template&id=d67b46f8&scoped=true"
import script from "./ShowHotelEdits.vue?vue&type=script&lang=js"
export * from "./ShowHotelEdits.vue?vue&type=script&lang=js"
import style0 from "./ShowHotelEdits.vue?vue&type=style&index=0&id=d67b46f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67b46f8",
  null
  
)

export default component.exports